import AdminSkillSizeEditPage from 'components/pages/admin/skill-sizes/admin-skill-sizes-edit-page'

export default AdminSkillSizeEditPage
